<template>
    <div>
        <div class="form flex a-center j-between mt--23">
            <div class="form-left ml--30">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="公司名称:" prop="name" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.name" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="经营范围:" prop="businessScope" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.businessScope" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="通讯地址:" prop="mailingAddress" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.mailingAddress" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="法人代表:" prop="legalRepresentative" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.legalRepresentative" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="车辆运营类型:" prop="operationType" class="unset_m" style="margin-right: 15px;">
                        <el-select :popper-append-to-body="false" v-model="searchForm.operationType" placeholder="请选择">
                            <el-option label="公交" value="公交车"></el-option>
                            <el-option label="出租车" value="出租车"></el-option>
                            <el-option label="网约车" value="网约车"></el-option>
                            <el-option label="客运" value="客运"></el-option>
                            <el-option label="郊游" value="郊游"></el-option>
                            <el-option label="危险品" value="危险品"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="form-right mr--24 mb--22">
                <el-button class="search-button h--40 w--90 fs--14" icon="el-icon-search" type="primary" size="small"
                    @click="search">查询</el-button>
                <el-button @click="reset" icon="el-icon-refresh-right" class="reset-button h--40 w--90 fs--14"
                    size="small">重置</el-button>
            </div>
        </div>
        <div class="table-box ml--30 mt--23 mr--30">
            <el-table :data="tableData" border stripe style="width: 100%" :height="height">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="name" label="公司名称"></el-table-column>
                <el-table-column prop="businessScope" label="经营范围"></el-table-column>
                <el-table-column prop="operationType" label="运营类型"></el-table-column>
                <el-table-column prop="mailingAddress" label="通讯地址"></el-table-column>
                <el-table-column prop="registeredCapital" label="注册资本"></el-table-column>
                <el-table-column prop="legalRepresentative" label="法定代表人"></el-table-column>
                <el-table-column prop="contactPerson" label="联系人"></el-table-column>
                <el-table-column prop="contactNumber" label="联系电话"></el-table-column>
                <el-table-column prop="name" label="操作">
                    <template slot-scope="scope">
                        <el-button v-permission="29" @click="showDetail(scope.row)" size="small" type="primary">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="relative mt--23 flex j-end">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-size="pageSize" background 
                    layout="total,sizes,prev, pager, next,jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <DetailModal ref="detailModal" />
    </div>
</template>

<script>
import DetailModal from "./component/detailModal"
import { getEnterpriseList } from './service'

export default {
    components: {
        DetailModal
    },
    data() {
        return {
            searchForm: {
                name: '',
                businessScope: '',
                mailingAddress: '',
                legalRepresentative: '',
                operationType: ''
            },
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0
        };
    },
    computed: {
        height() {
            return this.$baseTableHeight()
        },
    },
    created() {
        this.$checkPermission(28)
        this.getList()
    },
    methods: {
        getList() {
            const params = {
                ...this.searchForm,
                pageCurr: this.currentPage,
                pageSize: this.pageSize
            };
            
            getEnterpriseList(params).then(res => {
                if (res && res.records) {
                    this.tableData = res.records;
                    this.total = res.total;
                }
            })
        },
        showDetail(row) {
            this.$refs.detailModal.dialogVisible = true;
            this.$refs.detailModal.companyData = row;
        },
        reset() {
            this.searchForm = {
                name: '',
                businessScope: '',
                mailingAddress: '',
                legalRepresentative: '',
                operationType: ''
            };
            this.currentPage = 1;
            this.getList();
        },
        search() {
            this.currentPage = 1;
            this.getList();
        },
        handleSizeChange(size) {
            this.pageSize = size;
            this.getList();
        },
        handleCurrentChange(page) {
            this.currentPage = page;
            this.getList();
        },
    }
}
</script>

<style scoped lang="less">
::v-deep .el-form-item .el-input__inner {
    width: 240px;
}
</style>